import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import SidebarMenuList from '../Simple/SidebarMenu/SidebarMenuList';
import { IMenuItem } from '../../lib/interfaces/MenuItem';
import paths from '../../lib/consts/paths';
import { getTrainingApisToken } from '../../api/apiRequests/user';

const UserProfileSidebar: FC = () => {
	const { t } = useTranslation();
	const { page } = useParams();
	const { root } = paths.userProfile;
	const { profile, orders, trainingEmails } = paths.userProfile.params;

	const { data: trainingToken } = useQuery<{ token: string }, Error>(
		['trainingToken'],
		() => getTrainingApisToken(),
	);

	const items: IMenuItem[] = [
		{
			itemName: t('profile'),
			icon: null,
			navigationLink: `${root}/${profile}`,
			slug: 'profile',
			isCurrent: page === profile,
		},
		{
			itemName: t('orders'),
			icon: null,
			navigationLink: `${root}/${orders}`,
			slug: 'orders',
			isCurrent: page === orders,
		},
	];

	if (trainingToken) {
		items.push({
			itemName: t('Training emails'),
			icon: null,
			navigationLink: `${root}/${trainingEmails}`,
			slug: 'training-emails',
			isCurrent: page === trainingEmails,
		});
	}
	return <SidebarMenuList items={items} />;
};

export default UserProfileSidebar;
